import React from 'react';
import { useDispatch } from 'react-redux';

import { DialogProps } from '@rikstv/play-common/src/components/coverPage/coverpage.types';
import { PlayerDialog } from '@rikstv/play-common/src/components/playerDialog';
import { commonUpgrade } from '@rikstv/play-common/src/forces/loadUserInfo/actions';

export const PlayerNoAccessDialog: React.FC<DialogProps['NoAccess']> = ({ posterUrl }) => {
  const dispatch = useDispatch();
  const dispatchUpgradeAction = () => dispatch(commonUpgrade({ fromAssetId: undefined }));
  const heading = 'Du har dessverre ikke tilgang til dette innholdet';
  const footer = 'For å få tilgang må du endre abonnementet ditt på Min side';

  return (
    <PlayerDialog
      heading={heading}
      linkOrClickHandler={dispatchUpgradeAction}
      buttonText="Få tilgang"
      posterUrl={posterUrl}
      footer={footer}
    />
  );
};
